import "../App.css";
import Game from "../components/game-components/Game";

function GamePage() {
  return (
   <div className="gameWindow">
      <Game />
   </div>
  );
}

export default GamePage;